import React from 'react';
import SEO from '../components/common/SEO';
import BlogList from '../components/pages/homePage/BlogList/BlogList';
import HomePageLayout from '../components/pages/homePage/HomePageLayout/HomePageLayout';
import { graphql } from 'gatsby';

export const query = graphql`
  query($categoryIds: [ID]) {
    wpgraphql {
      posts(first: 4, where: { categoryIn: $categoryIds }) {
        nodes {
          date
          excerpt
          title
          slug
          id
          content
          author {
            node {
              name
            }
          }
          featuredImage {
            node {
              altText
              mediaItemUrl
            }
          }
          categories {
            nodes {
              name
              databaseId
              uri
              slug
            }
          }
          uri
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export default function HomePageTemplate({ data, pageContext }) {
  return (
    <>
      <SEO
        title="Feeding India Blog"
        description="Serving daily meals for a hunger-free India"
        image="https://b.zmtcdn.com/data/o2_assets/b90ed7f7c7f06ce7a5b94b967d4ce3eb1621255947.png"
      />
      <HomePageLayout categories={pageContext.categories}>
        <BlogList
          posts={data.wpgraphql.posts}
          categoryIds={pageContext.categoryIds}
        />
      </HomePageLayout>
    </>
  );
}
